import React, {createContext} from 'react';
const InsightContext = createContext(null);
export {InsightContext};